import { ConfigProvider, ConfigProviderProps } from 'antd'

import { BasicProps } from '@eastcoal/common/types/component'

import { ToolbarActionBar } from './ActionBar'
import { ToolbarActionGroup } from './ActionGroup'
import { ToolbarStoreProvider } from './Store'

const theme: ConfigProviderProps['theme'] = {
  components: {
    Tooltip: {
      colorBgBase: '#4e5561'
    }
  }
}

export const Toolbar = (props: BasicProps) => {
  return (
    <ConfigProvider componentSize='small' theme={theme}>
      <ToolbarStoreProvider>
        <ToolbarActionBar {...props}>
          <ToolbarActionGroup />
        </ToolbarActionBar>
      </ToolbarStoreProvider>
    </ConfigProvider>
  )
}
